import { FETCH_CMSPAGE_FULFILLED, FETCH_CMSPAGE_REJECTED } from '../actions/getCmsPage';
import { CLEAR_CMSPAGE } from '../actions/clearCmsPage';
import { CLEAR_SPECIFIC_CMSPAGES } from '../actions/clearSpecificCmsPages';

export default function (state: any = {}, action: any) {
  const switchCase = (action.meta?.pageUrl === '/page-not-found' || action.payload?.response?.data?.pageURL === '/page-not-found')
  ? FETCH_CMSPAGE_REJECTED : FETCH_CMSPAGE_FULFILLED;
  switch (action.type) {
    case switchCase:
      return {
        ...state,
        [`${action.meta.pageUrl}-${action.meta.language}`]:
          action?.payload?.data || action?.payload?.response?.data || {},
      };
    case CLEAR_CMSPAGE:
      return {};
    case CLEAR_SPECIFIC_CMSPAGES:
      const newState = { ...state };
      action.payload.forEach((url: string) => {
        Object.keys(newState).forEach(key => {
          if (newState[key]?.pageURL === url) {
            delete newState[key];
          }
        });
      });
      return newState;
    default:
      return state;
  }
}
